var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Card_black",
    "data-name": "Card black",
    transform: "translate(-3446 -240)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 512,
    height: 512,
    transform: "translate(3446 240)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(2758.071 -409.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    transform: "matrix(0.921, 0.391, -0.391, 0.921, 880.025, 649.57)",
    fill: "#414040",
    stroke: "#292828",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("rect", {
    width: 317.703,
    height: 421.36,
    rx: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 307.703,
    height: 411.36,
    rx: 10,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(920.136 830.473) rotate(22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M11.776,1.67A7.615,7.615,0,0,0,1.083,2.843,7.283,7.283,0,0,0,0,4.793c.051-.014.1-.038.149-.05a4.3,4.3,0,0,1,1.881,8.382c-.065.015-.128.012-.192.023.137.132.269.267.42.388A7.606,7.606,0,1,0,11.776,1.67Z",
    transform: "translate(26.671 44.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M11.777,1.67A7.616,7.616,0,0,0,1.083,2.843,7.3,7.3,0,0,0,0,4.793c.051-.014.1-.038.149-.05a4.3,4.3,0,0,1,1.881,8.382c-.064.015-.127.012-.192.023.137.132.269.267.421.388A7.606,7.606,0,1,0,11.777,1.67Z",
    transform: "translate(59.699 44.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M84.07,14.227a13.425,13.425,0,0,1,1.907-1.206c.358-.191.7-.352,1.036-.5A7.578,7.578,0,1,0,85.191,7.29q-.8.279-1.588.624a18.158,18.158,0,0,0-2.861,1.528,19.91,19.91,0,0,0-2.711,2.071,20.3,20.3,0,0,0-5.617,8.575,45.593,45.593,0,0,0-22.207-5.763h-.028a45.593,45.593,0,0,0-22.207,5.763,20.3,20.3,0,0,0-5.617-8.575,19.91,19.91,0,0,0-2.711-2.071,18.157,18.157,0,0,0-2.861-1.528Q16,7.568,15.194,7.29a7.645,7.645,0,1,0-1.822,5.227c.336.151.678.312,1.036.5a13.464,13.464,0,0,1,1.907,1.206,14.071,14.071,0,0,1,1.839,1.635A14.859,14.859,0,0,1,22,24.059,45.734,45.734,0,0,0,4.325,60.179L15.46,58.473l.55,1.707A19.65,19.65,0,0,0,50.193,62.22a19.65,19.65,0,0,0,34.183-2.041l.55-1.707,11.136,1.707a45.734,45.734,0,0,0-17.672-36.12,14.854,14.854,0,0,1,3.842-8.2A14.024,14.024,0,0,1,84.07,14.227Zm-50.4,51.662A14.342,14.342,0,1,1,48.01,51.547,14.359,14.359,0,0,1,33.667,65.889ZM81.061,51.547A14.343,14.343,0,1,1,66.718,37.2,14.359,14.359,0,0,1,81.061,51.547Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M17.047,3.33A45.447,45.447,0,0,1,0,0L17.034,12.717,34.062.012A45.411,45.411,0,0,1,17.047,3.33Z",
    transform: "translate(33.15 108.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M86.177,0a134.038,134.038,0,0,1-43.2,7.314A133.958,133.958,0,0,1,0,.081,45.818,45.818,0,0,0,13.624,19.735c5.364,2.267,14.8,4.983,29.349,4.983,14.872,0,24.423-2.841,29.72-5.137A45.8,45.8,0,0,0,86.177,0Z",
    transform: "translate(7.123 75.4)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBlack);
export default __webpack_public_path__ + "static/media/card_black.118192fbb955fa753b59aeefe1fe2115.svg";
export { ForwardRef as ReactComponent };